import type { $Fetch } from "ofetch";

const controller = "/ini";
/**
 * Tipo da resposta da API de RSS
 */
export type RSSResponse = string; // Aqui, retornaremos o conteúdo do RSS como uma string

/**
 * Classe de gerenciamento de chamadas da API de RSS
 *
 * @class
 */
export default class RSSApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe RSSApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */

  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Retorna o conteúdo do RSS
   * @returns string
   */
  
  async get(): Promise<RSSResponse> {
    return await this.api(`${controller}/CarregarIniBlob`);
  }

  /**
   * Retorna o conteúdo do RSS
   * @returns string
   */

  async post(): Promise<RSSResponse> {
    return await this.api(`${controller}/CadastrarIniBlob`);
  }
}
